/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_ExpiredInputs */

const cs_enum_expired = /** @type {(inputs: Enum_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vypršelo`)
};

const en_enum_expired = /** @type {(inputs: Enum_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expired`)
};

/**
* | output |
* | --- |
* | "Expired" |
*
* @param {Enum_ExpiredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_expired = /** @type {((inputs?: Enum_ExpiredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_ExpiredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_expired(inputs)
	return cs_enum_expired(inputs)
});